import React, { useEffect, useCallback } from "react";
import {
  Form,
  Row,
  Modal,
  Typography,
  Button,
  Col,
  notification,
  Select,
} from "antd";
import SubtenantApi from "../../Apis/SubtenantApi";
import TenantApi from "../../Apis/TenantApi";
const { Title } = Typography;
function Subtenants({ visible, onClose }) {
  const [form] = Form.useForm();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [TenantData, setTenantData] = React.useState();

  const [Tenants, setTenant] = React.useState([]);
  const getSubtenant = useCallback(() => {
    TenantApi.tenantsList().then((response) => {
      setTenant(response.payloadDto);
    })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    getSubtenant();
  }, []);

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      tenantId: TenantData?.id,
      subTenantCode: TenantData?.tenantCode,
      subTenantName: TenantData?.tenantName,
      subTenantApiKey: TenantData?.tenantApiKey,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    SubtenantApi.Createsubtenants(formData)
      .then((response) => {

        onClose();
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Created</span>,
          description: "Created Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        form.resetFields();
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>Error</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleChangetenant = (value) => {
    setTenantData(JSON.parse(value))
  };

  return (
    <>
      <Modal
        footer={[]}
        width={600}
        visible={visible}
        onCancel={onClose}
        maskClosable={false}
        onOk={onClose}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          Add Sub Tenants
        </Title>
        <Form
          form={form}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          <>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  name="SubTenants"
                  label="Sub Tenants"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Sub Tenants",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="control-Select mb-1"
                    placeholder="Select Sub Tenants"
                    onChange={(value) =>
                      handleChangetenant(value)
                    }
                    filterOption={(input, option) =>
                      option.props.children && option.props.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {Tenants.map((option, index) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.tenantName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

            </Row>

            <div className="d-flex justify-content-center pt-1">
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "37%" }}
              >
                Save
              </Button>

            </div>
          </>
        </Form>

      </Modal>

    </>
  );
}

export default Subtenants;
